import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux"; // Import useSelector
import nocover from "./../assets/images/nocover.jpg";
import SkeletonProductDetails from "./../loaders/SkeletonProductDetails";
import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/apiConfig";
import { Book, Layers, FileCopy } from "@mui/icons-material";
import { addToCart } from "../redux/cartSlice";
import "./ProductDetails.css";

const ProductDetails = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    // const userId = useSelector((state) => state.auth.userId); // Get userId from Redux
    const userId = useSelector((state) => state.auth.user?.id); // Ensure `user` exists before accessing `id`
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [cartMessage, setCartMessage] = useState("");

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const response = await axiosInstance.get(`${API_ENDPOINTS.PRODUCT_DETAILS}/${id}`);
                setProduct(response.data.data);
            } catch (error) {
                console.error("Error fetching product details:", error);
                setError("Failed to load product details");
            } finally {
                setLoading(false);
            }
        };
        fetchProduct();
    }, [id]);

    const handleAddToCart = async () => {
        if (!userId) {
            setCartMessage("❌ Please log in to add items to the cart.");
            return;
        }
        if (!product) return;

        const cartItem = {
            productId: product.id,
            productName: product.name,
            quantity: 1,
            bookId: product.bookId,
            productPrice: product.price,
            imageUrls: product.imageUrls[0],
        };

        console.log("cart items",cartItem)
        dispatch(addToCart(cartItem));

        try {
            await axiosInstance.post(API_ENDPOINTS.ADD_TO_CART, { userId, cartItems: [cartItem] });
            setCartMessage("✅ Added to cart successfully!");
        } catch (error) {
            console.error("Error adding to cart:", error);
            setCartMessage("❌ Failed to add to cart.");
        }

        setTimeout(() => setCartMessage(""), 3000);
    };

    if (loading) return <SkeletonProductDetails />;
    if (error) return <div className="container mt-4 text-danger">{error}</div>;

    return (
        <div className="container mt-4">
            <div className="row">
                <div className="col-md-4 col-12 text-center">
                    <img src={product.imageUrls?.[0] || nocover} alt="Product" className="img-fluid rounded" />
                    {cartMessage && <div className="alert alert-info mt-3">{cartMessage}</div>}
                    <div className="d-none d-md-flex gap-3 mt-3 flex-wrap justify-content-center">
                        <button className="btn btn-light btn-lg flex-grow-1" onClick={handleAddToCart}>
                            Add to cart
                        </button>
                        <button className="btn btn-warning btn-lg flex-grow-1">Buy now</button>
                    </div>
                </div>
                <div className="col-md-8 col-12 mt-4 mt-md-0">
                    <h5 className="mt-3 fw-bold text-truncate">{product.name}</h5>
                    <div className="border p-3 rounded">
                        <p>{product.description || "No description available."}</p>
                        <div className="highlight-container">
                            {[
                                { icon: <Book className="highlight-icon" />, label: "Language", value: product.language || "N/A" },
                                { icon: <FileCopy className="highlight-icon" />, label: "Pages", value: product.pages || "N/A" },
                                { icon: <Layers className="highlight-icon" />, label: "File Size", value: product.fileSize || "N/A" },
                            ].map((item, index) => (
                                <div key={index} className="highlight-box">
                                    {item.icon}
                                    <div className="highlight-label">{item.label}:</div>
                                    <div className="highlight-value">{item.value}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <h4 className="mt-4">Specifications</h4>
                    <div className="border p-3 rounded">
                        <h5>📌 Book Details</h5>
                        <p>
                            <strong>Imprint:</strong> {product.imprint || "N/A"}
                        </p>
                        <p>
                            <strong>Publication Year:</strong> {product.year || "N/A"}
                        </p>
                        <p>
                            <strong>Net Quantity:</strong> {product.quantity || "N/A"}
                        </p>
                    </div>
                </div>
            </div>
            <div className="fixed-bottom-buttons d-md-none">
                <button type="button" className="btn btn-light" onClick={handleAddToCart}>
                    Add to cart
                </button>
                <button className="btn btn-warning">Buy now</button>
            </div>
        </div>
    );
};

export default ProductDetails;